import React from 'react'
import PopupManager from '../../components/website/PopupManager'

export default function PopupEditor() {
  return <PopupManager />
}
